import React, { useContext, useEffect, useState } from 'react';
import KpiDefinitionData from 'service/KpiDefinitionData';
import { useOverview } from '../../../../hooks/overview-hook';
import { useMetricsCriteria } from '../../../../hooks/useMetricsCriteria';
import { FilterContext } from '../../../../components/FilterBar/FilterProvider';
import CardContainer from '../../../../components/redesign/CardContainer';
import { KpiData } from 'components/redesign/KpiTile/types';
import KpiGrid from '../../../../components/redesign/KpiGrid';
import KpiTile from 'components/redesign/KpiTile';
import activeUsers from '../../../../v2/kpis/rgm/app/userAdoption/activeUsers';
import { constants } from 'constants/Constants';

interface SummaryMetricsPepIRisProps {
  title?: string;
}

const SummaryMetricsPepIRis: React.FC<SummaryMetricsPepIRisProps> = ({
  title,
}) => {
  const [overViewConfig, setOverviewConfig] = useState<KpiData[]>([]);
  const {
    userBehaviorAndEngagementData,
    getUserBehaviourAndEngagementData,
    userBehaviorAndEngagementLoading,
  } = useOverview();
  const { operationalMetricCriteria } = useMetricsCriteria();
  const { selectedProduct } = useContext(FilterContext);

  useEffect(() => {
    if (selectedProduct?.productId === constants?.products?.PepIRiS) {
      const overviewMetricCriteria = { ...operationalMetricCriteria };
      getUserBehaviourAndEngagementData({
        variables: { overviewMetricCriteria },
      });
    }
  }, [
    getUserBehaviourAndEngagementData,
    operationalMetricCriteria,
    selectedProduct,
  ]);

  useEffect(() => {
    if (userBehaviorAndEngagementData) {
      const data = {
        getUserAdoptionScorecard: {
          ...userBehaviorAndEngagementData?.userBehaviour,
        },
      };
      const updatedOverviewConfig = [activeUsers.handler(data)];
      setOverviewConfig(updatedOverviewConfig);
    }
  }, [userBehaviorAndEngagementData]);

  return (
    <CardContainer
      isLoading={userBehaviorAndEngagementLoading}
      title={title}
      showInfoIcon={true}
      dataDefinitions={{
        sections:
          KpiDefinitionData[selectedProduct?.productId]
            ?.userBehaviorAndEngagement?.scoreCard ?? [],
      }}
      isAccordion={false}
    >
      <KpiGrid
        columnsDesktop={4}
        columnsTablet={4}
        columnsMobile={1}
        showBorderDesktop={false}
      >
        {overViewConfig.map((item, index) => (
          <KpiTile key={index} data={item} />
        ))}
      </KpiGrid>
    </CardContainer>
  );
};

export default SummaryMetricsPepIRis;
